import { COMMON_ERRORS } from "@storyline/shared";

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null;

export const getApiErrorCode = (value: unknown): string | null => {
	if (isRecord(value) && typeof value.code === "string") {
		return value.code;
	}
	return null;
};

export const getApiErrorMessage = (value: unknown): string => {
	if (isRecord(value) && typeof value.message === "string") {
		return value.message;
	}
	return COMMON_ERRORS.INTERNAL_ERROR.message;
};

const toStatus = (value: unknown): number => (typeof value === "number" ? value : 500);

const getApiErrorDetails = (value: unknown): Record<string, unknown> | null => {
	if (isRecord(value) && isRecord(value.details)) {
		return value.details;
	}
	return null;
};

export class HttpError extends Error {
	readonly status: number;
	readonly code: string;
	readonly details: Record<string, unknown> | null;

	constructor(status: unknown, value: unknown) {
		super(getApiErrorMessage(value));
		this.name = "HttpError";
		this.status = toStatus(status);
		this.code = getApiErrorCode(value) ?? COMMON_ERRORS.INTERNAL_ERROR.code;
		this.details = getApiErrorDetails(value);
	}
}

type TreatyResult<T> = {
	data: T | null;
	error: { status: unknown; value: unknown } | null;
};

export const unwrap = <T>(result: TreatyResult<T>): T => {
	if (result.error) {
		throw new HttpError(result.error.status, result.error.value);
	}
	if (result.data === null) {
		throw new HttpError(500, null);
	}
	return result.data;
};
